var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { domel } from '@easydata/ui';
import { EasyDataTable, DataType, utils as dataUtils, i18n } from '@easydata/core';
import { EasyGrid } from '@easydata/ui';
import { FacetType } from '../types/facet_type';
import { ResultFacet } from './result_facet';
import { browserUtils } from '../utils/browser_utils';
var AggrFunc;
(function (AggrFunc) {
    AggrFunc["Sum"] = "SUM";
    AggrFunc["Average"] = "AVG";
    AggrFunc["Min"] = "MIN";
    AggrFunc["Max"] = "MAX";
    AggrFunc["Count"] = "COUNT";
})(AggrFunc || (AggrFunc = {}));
var FormFieldType;
(function (FormFieldType) {
    FormFieldType[FormFieldType["ColumnField"] = 0] = "ColumnField";
    FormFieldType[FormFieldType["RowField"] = 1] = "RowField";
    FormFieldType[FormFieldType["CellData"] = 2] = "CellData";
})(FormFieldType || (FormFieldType = {}));
var DFMT_REGEX = /{0:(.*?)}/g;
var PivotTableFacet = /** @class */ (function (_super) {
    __extends(PivotTableFacet, _super);
    function PivotTableFacet() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.title = i18n.getText('Facets', 'Pivot', 'FacetTitle');
        _this.dialogTitle = i18n.getText('Facets', 'Pivot', 'DlgTitle');
        _this.pivotTable = new EasyDataTable();
        return _this;
    }
    PivotTableFacet.prototype.init = function (slot) {
        var _this = this;
        _super.prototype.init.call(this, slot);
        this.options.maxRowCount = this.options.maxRowCount || 500;
        this.options.viewportRowsCount = this.options.viewportRowsCount || 50;
        this.grid = new EasyGrid({
            slot: this.contentDiv,
            dataTable: this.pivotTable,
            paging: {
                enabled: false,
                pageSize: this.options.maxRowCount
            },
            viewportRowsCount: this.options.viewportRowsCount,
            useRowNumeration: false,
            showPlusButton: false,
            allowDragDrop: false,
            onGetCellRenderer: function (column, defaultRenderer) {
                if (column.dataColumn) {
                    if (column.dataColumn.id == "total") {
                        return function (value, column, cell, rowEl) {
                            defaultRenderer(value, column, cell, rowEl);
                            cell.classList.add('pivot-cell-total');
                        };
                    }
                    if (_this.settings.totalsRow) {
                        var colIndex = _this.pivotTable.columns.getIndex(column.dataColumn.id);
                        var isFirst = colIndex === 0;
                        if (isFirst) {
                            return function (value, column, cell, rowEl) {
                                var idx = Number.parseInt(rowEl.getAttribute('data-row-idx'));
                                var isLast = idx === _this.pivotTable.getCachedCount() - 1;
                                if (isLast) {
                                    value = i18n.getText('Facets', 'Pivot', 'TotalGridLabel');
                                }
                                defaultRenderer(value, column, cell, rowEl);
                            };
                        }
                    }
                }
            }
        });
    };
    PivotTableFacet.prototype.getType = function () {
        return FacetType.PivotTable;
    };
    PivotTableFacet.prototype.destroy = function () {
        if (this.grid) {
            this.grid.destroy();
        }
    };
    PivotTableFacet.prototype.createAggrFuncSelectBuilder = function (aggrFunc) {
        var model = this.getContext().getModel();
        var csb = domel('select');
        var aggrfuncs = Object.keys(AggrFunc).map(function (k) { return AggrFunc[k]; });
        var _loop_1 = function (aggrfunc) {
            csb.addChild('option', function (b) {
                b
                    .attr('value', aggrfunc)
                    .text(model.getAggrFunctionCaption(aggrfunc));
            });
        };
        for (var _i = 0, aggrfuncs_1 = aggrfuncs; _i < aggrfuncs_1.length; _i++) {
            var aggrfunc = aggrfuncs_1[_i];
            _loop_1(aggrfunc);
        }
        var options = csb.toDOM().querySelectorAll('option');
        if (aggrFunc != undefined) {
            options.forEach(function (option) {
                if (option.value == aggrFunc) {
                    option.selected = true;
                }
            });
        }
        else {
            options[0].selected = true;
        }
        return csb;
    };
    PivotTableFacet.prototype.createColumnsSelectBuilder = function (allowedTypes, colName, formFieldType) {
        var dataTable = this.getContextDataTable();
        var csb = domel('select');
        var firstNumericColIndex = null;
        var optionIndex = 0;
        var _loop_2 = function (i) {
            var column = dataTable.columns.get(i);
            var colLabel = column.label;
            var colType = column.type;
            var colId = column.id;
            if (allowedTypes && allowedTypes.indexOf(colType) < 0)
                return "continue";
            if (firstNumericColIndex === null && dataUtils.isNumericType(colType)) {
                firstNumericColIndex = optionIndex;
            }
            csb.addChild('option', function (b) {
                b
                    .attr('value', colId)
                    .text(colLabel);
            });
            optionIndex++;
        };
        for (var i = 0; i < dataTable.columns.count; i++) {
            _loop_2(i);
        }
        var options = Array.from(csb.toDOM().querySelectorAll('option'));
        if (options.length > 0) {
            if (colName != undefined) {
                for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
                    var option = options_1[_i];
                    if (option.value == colName) {
                        csb.toDOM().value = option.value;
                        break;
                    }
                }
            }
            else {
                switch (formFieldType) {
                    case FormFieldType.ColumnField: {
                        csb.toDOM().value = options[0].value;
                        break;
                    }
                    case FormFieldType.RowField: {
                        csb.toDOM().value = options.length > 1 ? options[1].value : options[0].value;
                        break;
                    }
                    case FormFieldType.CellData: {
                        csb.toDOM().value = firstNumericColIndex === null ? options[0].value : options[firstNumericColIndex].value;
                        break;
                    }
                }
            }
        }
        return csb;
    };
    PivotTableFacet.prototype.renderFormFields = function (form, fieldsContainer) {
        var _this = this;
        _super.prototype.renderFormFields.call(this, form, fieldsContainer);
        var settings = this.settings || { totalsRow: true, totalsCol: true };
        var colTypes = [DataType.String, DataType.Date, DataType.DateTime, DataType.Int32,
            DataType.Int64, DataType.Word, DataType.Byte];
        var fieldTypes = [DataType.String, DataType.Float, DataType.Int32,
            DataType.Int64, DataType.Word, DataType.Byte, DataType.Currency];
        var isIE = browserUtils.isIE();
        var current = fieldsContainer;
        var horizClass = isIE ? 'kfrm-fields-ie is-horizontal' : 'kfrm-fields is-horizontal';
        var getCurrent = function () {
            if (isIE) {
                return domel('div', fieldsContainer)
                    .addClass('kfrm-field-ie')
                    .toDOM();
            }
            else {
                return fieldsContainer;
            }
        };
        if (isIE) {
            domel(fieldsContainer)
                .addChildElement(getCurrent());
        }
        else {
            domel(fieldsContainer)
                .addChild('div')
                .addChild('div');
        }
        current = getCurrent();
        domel(current)
            .addChild('label', function (b) { return b
            .attr('for', 'column_field')
            .text(i18n.getText('Facets', 'Pivot', 'ColumnFieldSelectorLabel')); })
            .addChild('div', function (b) { return b
            .addClass(horizClass)
            .addChild('div', function (b) { return b
            .addClass('kfrm-select')
            .attr('name', 'column_field')
            .addChildElement(_this.createColumnsSelectBuilder(colTypes, settings.colName, FormFieldType.ColumnField)
            .id('pivotTableColFieldSelector')
            .toDOM()); })
            .addChild('button', function (b) { return b
            .addClass('kfrm-button')
            .addClass('eqjs-facets-button-swap')
            .attr('title', i18n.getText('Facets', 'Pivot', 'SwapBtnTitle'))
            .on('click', function () {
            var colSelect = document.getElementById('pivotTableColFieldSelector');
            var rowSelect = document.getElementById('pivotTableRowFieldSelector');
            var tmp = colSelect.value;
            colSelect.value = rowSelect.value;
            rowSelect.value = tmp;
        }); }); });
        current = getCurrent();
        domel(current)
            .addChild('label', function (b) { return b
            .attr('for', 'row_field')
            .text(i18n.getText('Facets', 'Pivot', 'RowFieldSelectorLabel')); })
            .addChild('div', function (b) { return b
            .addClass('kfrm-select')
            .attr('name', 'row_field')
            .addChildElement(_this.createColumnsSelectBuilder(colTypes, settings.rowName, FormFieldType.RowField)
            .id('pivotTableRowFieldSelector')
            .toDOM()); });
        current = getCurrent();
        domel(current)
            .addChild('label', function (b) { return b
            .attr('for', 'data_function')
            .text(i18n.getText('Facets', 'Pivot', 'CellDataSelectorLabel')); })
            .addChild('div', function (b) { return b
            .addClass(horizClass)
            .addChild('div', function (b) { return b
            .addClass('kfrm-select')
            .attr('name', 'data_function')
            .addChildElement(_this.createAggrFuncSelectBuilder(settings.aggrFunc)
            .id('pivotTableAggrFuncSelector')
            .toDOM()); })
            .addChild('label', function (b) { return b.addText('of  '); })
            .addChild('div', function (b) { return b
            .addClass('kfrm-select')
            .attr('name', 'data_column')
            .addChildElement(_this.createColumnsSelectBuilder(fieldTypes, settings.fieldName, FormFieldType.CellData)
            .on('change', function (ev) {
            var colId = ev.target.value;
            _this.validateSelectedField(colId);
        })
            .id('pivotTableCellFieldSelector')
            .toDOM()); }); });
        current = getCurrent();
        domel(current)
            .addChild('div')
            .addChild('div', function (b) { return b
            .addClass(horizClass)
            .addChild('label', function (b) { return b
            .addClass('checkbox')
            .addChild('input', function (b) {
            b
                .id('pivotTableHasTotalsRow')
                .type('checkbox');
            if (settings.totalsRow)
                b.attr('checked', '');
        })
            .addText(' ' + i18n.getText('Facets', 'Pivot', 'TotalsRowLabel')); })
            .addChild('label', function (b) { return b
            .addClass('checkbox')
            .addChild('input', function (b) {
            b
                .id('pivotTableHasTotalsCol')
                .type('checkbox');
            if (settings.totalsCol)
                b.attr('checked', '');
        })
            .addText(' ' + i18n.getText('Facets', 'Pivot', 'TotalsColLabel')); }); });
    };
    PivotTableFacet.prototype.afterDialogOpened = function (dlg) {
        var colId = document.getElementById('pivotTableCellFieldSelector').value;
        if (colId) {
            this.validateSelectedField(colId);
        }
        if (this.getQuery().getColumns().length <= 2) {
            dlg.showAlert('The dataset should contain at least three columns to build a pivot table', 'error');
            dlg.getSubmitButtonElement().disabled = true;
        }
    };
    PivotTableFacet.prototype.validateSelectedField = function (colId) {
        var dataTable = this.getContextDataTable();
        var colIndex = dataTable.columns.getIndex(colId);
        var col = dataTable.columns.get(colIndex);
        var aggrSelector = document.getElementById('pivotTableAggrFuncSelector');
        if (col.type == DataType.String) {
            aggrSelector.disabled = true;
            aggrSelector.value = AggrFunc.Count;
        }
        else {
            aggrSelector.disabled = false;
        }
    };
    PivotTableFacet.prototype.submitSettingsDialog = function () {
        var result = _super.prototype.submitSettingsDialog.call(this);
        if (result) {
            this.settings = {
                colName: document.getElementById('pivotTableColFieldSelector').value,
                rowName: document.getElementById('pivotTableRowFieldSelector').value,
                aggrFunc: document.getElementById('pivotTableAggrFuncSelector').value,
                fieldName: document.getElementById('pivotTableCellFieldSelector').value,
                totalsRow: document.getElementById('pivotTableHasTotalsRow').checked,
                totalsCol: document.getElementById('pivotTableHasTotalsCol').checked
            };
            this.refresh();
        }
        return result;
    };
    PivotTableFacet.prototype.saveToData = function () {
        var data = _super.prototype.saveToData.call(this);
        if (this.settings) {
            dataUtils.assignDeep(data, this.settings);
        }
        return data;
    };
    PivotTableFacet.prototype.loadFromData = function (data) {
        _super.prototype.loadFromData.call(this, data);
        if (data) {
            this.settings = dataUtils.assignDeep(this.settings, data);
            if (this.settings.aggrFunc == 'AVERAGE') {
                this.settings.aggrFunc = AggrFunc.Average;
            }
        }
    };
    PivotTableFacet.prototype.refreshCore = function () {
        this.updatePivotData();
        if (this.grid) {
            var dataSize = this.pivotTable.getTotal();
            var maxRow = this.grid.options.paging.pageSize;
            if (dataSize > maxRow) {
                this.contentDiv.classList.remove('pivot-grid-with-totals');
                this.showErrorMessage(i18n.getText('Facets', 'ErrTooMuchData'));
            }
            if (this.options.viewportRowsCount > dataSize) {
                this.grid.options.viewportRowsCount = dataSize;
            }
            else {
                this.grid.options.viewportRowsCount = this.options.viewportRowsCount;
            }
            this.grid.refresh();
        }
    };
    PivotTableFacet.prototype.getContextDataTable = function () {
        var context = this.getContext();
        return context.resultTable;
    };
    PivotTableFacet.prototype.updatePivotData = function () {
        this.pivotTable.clear();
        var dataTable = this.getContextDataTable();
        if (!dataTable || dataTable.getTotal() == 0) {
            return;
        }
        if (!this.settings) {
            return;
        }
        var colName = this.settings.colName;
        var rowName = this.settings.rowName;
        var fieldName = this.settings.fieldName;
        var colIdx = dataTable.columns.getIndex(colName);
        var rowIdx = dataTable.columns.getIndex(rowName);
        var fieldIdx = dataTable.columns.getIndex(fieldName);
        if (colIdx == undefined || rowIdx == undefined || fieldIdx == undefined) {
            this.showUnableDisplayMessage(i18n.getText('Facets', 'ErrQueryChanged'));
            return;
        }
        var columnField = dataTable.columns.get(fieldIdx);
        var columnCol = dataTable.columns.get(colIdx);
        var columnRow = dataTable.columns.get(rowIdx);
        var rowLabel = columnRow.label;
        var rowType = columnRow.type;
        var colLabel = columnCol.label;
        var colValues = [];
        var rowValues = [];
        var rows = dataTable.getCachedRows();
        for (var i = 0; i < rows.length; i++) {
            var colValue = rows[i].getValue(colIdx);
            if (colValues.indexOf(colValue) < 0) {
                colValues.push(colValue);
            }
            var rowValue = rows[i].getValue(rowIdx);
            if (rowValues.indexOf(rowValue) < 0) {
                rowValues.push(rowValue);
            }
        }
        this.pivotTable.columns.add({
            id: rowLabel + '\\' + colLabel,
            label: rowLabel + '\\' + colLabel,
            description: '',
            type: rowType,
            dfmt: columnRow.displayFormat,
            style: columnRow.style
        });
        var null_columns = [];
        var colFieldFormatter = null;
        if (dataUtils.isNumericType(columnCol.type)) {
            colFieldFormatter = this.formatNumber;
        }
        else if (dataUtils.getDateDataTypes().indexOf(columnCol.type) >= 0) {
            colFieldFormatter = this.formatDate;
        }
        for (var i = 0; i < colValues.length; i++) {
            var colValue = colValues[i];
            if (!colValue) {
                null_columns.push(i);
            }
            else {
                var label = colFieldFormatter
                    ? colFieldFormatter(columnCol, colValue)
                    : colValue;
                this.pivotTable.columns.add({
                    id: colValue,
                    label: label,
                    description: '',
                    dfmt: columnField.displayFormat,
                    type: this.settings.aggrFunc !== AggrFunc.Count
                        ? columnField.type : DataType.Int64,
                    style: columnField.style
                });
            }
        }
        var new_rows = [];
        for (var i = 0; i < rowValues.length; i++) {
            new_rows.push([]);
            new_rows[i].push(rowValues[i]);
        }
        for (var i = 0; i < rowValues.length; i++) {
            for (var j = 0; j < colValues.length; j++) {
                if (null_columns.indexOf(j) >= 0)
                    continue;
                new_rows[i].push(this.calcAggrFunc(this.settings.aggrFunc, {
                    colName: this.settings.colName,
                    rowName: this.settings.rowName,
                    fieldName: this.settings.fieldName,
                    rowValue: rowValues[i],
                    colValue: colValues[j]
                }));
            }
        }
        if (this.settings.totalsCol) {
            this.pivotTable.columns.add({
                id: "total",
                label: i18n.getText('Facets', 'Pivot', 'TotalGridLabel'),
                description: '',
                dfmt: columnField.displayFormat,
                type: this.settings.aggrFunc !== AggrFunc.Count
                    ? columnField.type : DataType.Int64
            });
            for (var i = 0; i < new_rows.length; i++) {
                var row = new_rows[i];
                var totalByRow = 0;
                if (this.settings.aggrFunc == AggrFunc.Min
                    || this.settings.aggrFunc == AggrFunc.Max) {
                    totalByRow = row[1];
                }
                for (var j = 1; j < row.length; j++) {
                    var value = row[j];
                    if (value !== null) {
                        if (this.settings.aggrFunc === AggrFunc.Min) {
                            if (value < totalByRow)
                                totalByRow = value;
                        }
                        else if (this.settings.aggrFunc === AggrFunc.Max) {
                            if (value > totalByRow)
                                totalByRow = value;
                        }
                        else {
                            totalByRow += value;
                        }
                    }
                }
                if (this.settings.aggrFunc === AggrFunc.Average) {
                    totalByRow /= row.length - 1;
                }
                row.push(totalByRow);
            }
        }
        for (var _i = 0, new_rows_1 = new_rows; _i < new_rows_1.length; _i++) {
            var row = new_rows_1[_i];
            this.pivotTable.addRow(row);
        }
        if (this.settings.totalsRow) {
            var total_row = [];
            // to be able to create date value
            total_row.push(null);
            for (var i = 1; i < this.pivotTable.columns.count; i++) {
                var rows_1 = this.pivotTable.getCachedRows();
                var totalByCol = 0;
                if (this.settings.aggrFunc == AggrFunc.Min
                    || this.settings.aggrFunc == AggrFunc.Max) {
                    totalByCol = rows_1[0].getValue(i);
                }
                for (var j = 0; j < rows_1.length; j++) {
                    var value = rows_1[j].getValue(i);
                    if (value !== null) {
                        if (this.settings.aggrFunc === AggrFunc.Min) {
                            if (value < totalByCol)
                                totalByCol = value;
                        }
                        else if (this.settings.aggrFunc === AggrFunc.Max) {
                            if (value > totalByCol)
                                totalByCol = value;
                        }
                        else {
                            totalByCol += value;
                        }
                    }
                }
                if (this.settings.aggrFunc === AggrFunc.Average) {
                    totalByCol /= rows_1.length;
                }
                total_row.push(totalByCol);
            }
            this.pivotTable.addRow(total_row);
            this.contentDiv.classList.add('pivot-grid-with-totals');
        }
        else {
            this.contentDiv.classList.remove('pivot-grid-with-totals');
        }
    };
    PivotTableFacet.prototype.calcAggrFunc = function (func, options) {
        switch (func) {
            case AggrFunc.Sum:
                return this.sum(options);
            case AggrFunc.Average:
                return this.average(options);
            case AggrFunc.Min:
                return this.min(options);
            case AggrFunc.Max:
                return this.max(options);
            case AggrFunc.Count:
                return this.count(options);
            default:
                return 0;
        }
    };
    PivotTableFacet.prototype.getSettings = function () {
        return this.settings;
    };
    PivotTableFacet.prototype.formatDate = function (column, value) {
        var isDate = Object.prototype.toString.call(value) === '[object Date]';
        var strValue = (value || '').toString();
        if (isDate) {
            if (column && column.displayFormat
                && DFMT_REGEX.test(column.displayFormat)) {
                strValue = column.displayFormat.replace(DFMT_REGEX, function (_, $1) {
                    return i18n.dateTimeToStr(value, column.type, $1);
                });
            }
            else {
                var locale = i18n.getCurrentLocale();
                var timeOptions = { hour: 'numeric', minute: 'numeric', second: 'numeric' };
                switch (column.type) {
                    case DataType.Date:
                        strValue = value.toLocaleDateString(locale);
                        break;
                    case DataType.Time:
                        strValue = value.toLocaleTimeString(locale, timeOptions);
                        break;
                    case DataType.DateTime:
                        strValue = value.toLocaleDateString(locale) + " " + value.toLocaleTimeString(locale, timeOptions);
                        break;
                }
            }
        }
        return strValue;
    };
    PivotTableFacet.prototype.formatNumber = function (column, value) {
        var strValue = (value || '').toString();
        if (typeof value == 'number') {
            if (column && column.displayFormat
                && DFMT_REGEX.test(column.displayFormat)) {
                strValue = column.displayFormat.replace(DFMT_REGEX, function (_, $1) {
                    return i18n.numberToStr(value, $1);
                });
            }
            else {
                strValue = value.toLocaleString();
            }
        }
        return strValue;
    };
    PivotTableFacet.prototype.sum = function (options) {
        var result = 0;
        var dataTable = this.getContextDataTable();
        var rows = dataTable.getCachedRows();
        for (var i = 0; i < rows.length; i++) {
            var rowValue = rows[i].getValue(options.rowName);
            var colValue = rows[i].getValue(options.colName);
            if (rowValue !== options.rowValue
                || colValue !== options.colValue) {
                continue;
            }
            var fieldValue = rows[i].getValue(options.fieldName);
            result += fieldValue;
        }
        return result;
    };
    PivotTableFacet.prototype.average = function (options) {
        var result = 0;
        var count = 0;
        var dataTable = this.getContextDataTable();
        var rows = dataTable.getCachedRows();
        for (var i = 0; i < rows.length; i++) {
            var rowValue = rows[i].getValue(options.rowName);
            var colValue = rows[i].getValue(options.colName);
            if (rowValue !== options.rowValue
                || colValue !== options.colValue) {
                continue;
            }
            var fieldValue = rows[i].getValue(options.fieldName);
            result += fieldValue;
            count++;
        }
        if (count != 0)
            result = result / count;
        return result;
    };
    PivotTableFacet.prototype.min = function (options) {
        var min = Number.MAX_SAFE_INTEGER;
        var dataTable = this.getContextDataTable();
        var rows = dataTable.getCachedRows();
        for (var i = 0; i < rows.length; i++) {
            var rowValue = rows[i].getValue(options.rowName);
            var colValue = rows[i].getValue(options.colName);
            if (rowValue !== options.rowValue
                || colValue !== options.colValue) {
                continue;
            }
            var fieldValue = rows[i].getValue(options.fieldName);
            if (fieldValue < min) {
                min = fieldValue;
            }
        }
        if (min == Number.MAX_SAFE_INTEGER)
            return null;
        return min;
    };
    PivotTableFacet.prototype.max = function (options) {
        var max = Number.MIN_SAFE_INTEGER;
        var dataTable = this.getContextDataTable();
        var rows = dataTable.getCachedRows();
        for (var i = 0; i < rows.length; i++) {
            var rowValue = rows[i].getValue(options.rowName);
            var colValue = rows[i].getValue(options.colName);
            if (rowValue !== options.rowValue
                || colValue !== options.colValue) {
                continue;
            }
            var fieldValue = rows[i].getValue(options.fieldName);
            if (fieldValue > max) {
                max = fieldValue;
            }
        }
        if (max == Number.MIN_SAFE_INTEGER)
            return null;
        return max;
    };
    PivotTableFacet.prototype.count = function (options) {
        var dataTable = this.getContextDataTable();
        var count = 0;
        var rows = dataTable.getCachedRows();
        for (var i = 0; i < rows.length; i++) {
            var rowValue = rows[i].getValue(options.rowName);
            var colValue = rows[i].getValue(options.colName);
            if (rowValue !== options.rowValue
                || colValue !== options.colValue) {
                continue;
            }
            count++;
        }
        return count;
    };
    return PivotTableFacet;
}(ResultFacet));
export { PivotTableFacet };
//# sourceMappingURL=pivot_table_facet.js.map